module.exports = __webpack_public_path__ + "assets/no-invitation-code.2ba3fc25.svg";